<div class="content-page">


  <app-aside messageBackground="Evite senhas muito óbvias como datas ou palavras comuns"></app-aside>

  <main class="main-page">

    <app-top-bar [hideMenu]="true" TextoTopo="Identificação" action="/cadastro/confirmacao"></app-top-bar>
    <app-step-timeline  [itemActive]="3" [itens]="['Cadastro', 'Preferências', 'Token', 'Senha']"></app-step-timeline>

    <form [formGroup]="forFormGroup" (ngSubmit)="onSubmit()">

      <div class="container">

        <div class="row">
          <div class="col-1"></div>
          <div class="col">
            <h1 class="TtlPrin text-center">Tudo certo! <br> Agora só falta criar a {{update ? 'nova' : ''}} senha</h1>
          </div>
          <div class="col-1"></div>
        </div>

        <div class="row mt-5">
          <div class="col d-none d-md-block d-lg-block"></div>
          <div class="col col-md-6">
            <mat-form-field class="InputPadrao">
              <mat-label>Digite uma senha</mat-label>
              <input [type]="showPassword ? 'text' : 'password'" matInput required formControlName="Senha" minlength="8" (keyup)="handleChangeEvent($event)">
              <a (click)="showPassword = !showPassword" class="material-icons showPassword">
                <span *ngIf="showPassword==false">remove_red_eye</span>
                <span *ngIf="showPassword"><span class="material-icons">visibility_off</span></span>
              </a>
            </mat-form-field>

            <div class="RegrasPass">
              <mat-hint [ngStyle]="{'color': isSpecial ? '#004077' : 'green'}">
                <img *ngIf="isSpecial" src="../../../../assets/svg/icon-spinner.svg" alt="spinner">
                <img *ngIf="!isSpecial" src="../../../../assets/svg/icon-check-done-green.svg" alt="icon done">
                Use somente letras e números
              </mat-hint>
              <mat-hint [ngStyle]="{'color': !isMin ? '#004077' : 'green'}">
                <img *ngIf="!isMin" src="../../../../assets/svg/icon-spinner.svg" alt="spinner">
                <img *ngIf="isMin" src="../../../../assets/svg/icon-check-done-green.svg" alt="icon done">
                No mínimo 8 caracteres
              </mat-hint>
              <mat-hint [ngStyle]="{'color':!isLetter ? '#004077' : 'green'}">
                <img *ngIf="!isLetter" src="../../../../assets/svg/icon-spinner.svg" alt="spinner">
                <img *ngIf="isLetter" src="../../../../assets/svg/icon-check-done-green.svg" alt="icon done">
                No mínimo 1 letra
              </mat-hint>
              <mat-hint [ngStyle]="{'color':!isNumber ? '#004077' : 'green'}">
                <img *ngIf="!isNumber" src="../../../../assets/svg/icon-spinner.svg" alt="spinner">
                <img *ngIf="isNumber" src="../../../../assets/svg/icon-check-done-green.svg" alt="icon done">
                No mínimo 1 número
              </mat-hint>
            </div>
            <mat-form-field class="InputPadrao mt-64">
              <mat-label>Confirme a senha</mat-label>
              <input [type]="showPasswordConfirm ? 'text' : 'password'" matInput required formControlName="SenhaConfirmacao" minlength="8" (onChange)="handleChangeEvent($event)">
              <mat-error>As duas senhas não correspondem</mat-error>
              <a (click)="showPasswordConfirm = !showPasswordConfirm" class="material-icons showPassword">
                <span *ngIf="showPasswordConfirm==false">remove_red_eye</span>
                <span *ngIf="showPasswordConfirm"><span class="material-icons">visibility_off</span></span>
              </a>
            </mat-form-field>

            <div class="mt-4">
              <div class="d-flex justify-content-center">
                <button class="Btn BtnPadrao" type="submit" [disabled]="!forFormGroup.valid" mat-button>
                  {{ textBtn }} <mat-icon aria-hidden="false" aria-label="done">done</mat-icon>
                </button>
              </div>
            </div>
          </div>
          <div class="col d-none d-md-block d-lg-block"></div>
        </div>

      </div>

    </form>
    <app-footer></app-footer>
    
  </main>
  </div>

